export const columnKinds = {
  simple: 'simple',
  composite: 'composite'
};
